import { errorHandler } from "@/services/toastHandler";

export default {
  namespaced: true,
  state: {
    loadingMarketNameDropdown: false,
  },
  mutations: {
    LOAD_MARKET_NAME_DROPDOWN: (s, data) => (s.loadingMarketNameDropdown = data),
  },
  actions: {
    async getMarketNameDropdown({ commit }, { sportName, search }) {
      commit("LOAD_MARKET_NAME_DROPDOWN", true);
      try {
        const res = await this.$api.get(
          `/v1/portal/sport-events/market-names/${encodeURIComponent(sportName)}`,
          { params: { search: search || null } }
        );
        return res.data?.data || res.data || [];
      } catch (e) {
        errorHandler(e);
        return [];
      } finally {
        commit("LOAD_MARKET_NAME_DROPDOWN", false);
      }
    },
  },
};
